import { useEffect, useMemo } from 'react';

import { zustandStoreFactory } from '@shared/zustandStoreFactory';

type StoreState = {
  filters?: Record<string, any>;
  content?: string;
  setFilters: (filters: Record<string, any>) => void;
  setFilter: (key: string, value: any) => void;
  setContent: (content: string) => void;
};

const { Provider: FiltersStoreProvider, useStore: useFiltersStore } = zustandStoreFactory<StoreState>(
  (set) => ({
    filters: {},
    content: '',
    setFilters: (filters) => set(() => ({ filters }), false, 'setFilters'),
    setFilter: (key, value) => set((state) => ({ filters: { ...state.filters, [key]: value } }), false, 'setFilter'),
    setContent: (content) => set(() => ({ content }), false, 'setContent'),
  }),
  'Filters',
);
export { FiltersStoreProvider };

export const useFilters = (initValue?: StoreState): [Record<string, any>, (filters: Record<string, any>) => void] => {
  const filters = useFiltersStore((state) => state.filters);
  const setFilters = useFiltersStore((state) => state.setFilters);

  useEffect(() => {
    initValue && setFilters(initValue);
  }, [initValue, setFilters]);

  return [filters, setFilters];
};

export const useFilter = (key: string) => {
  const filters = useFiltersStore((state) => state.filters);
  const setFilter = useFiltersStore((state) => state.setFilter);

  const filter = useMemo(() => filters[key], [filters, key]);

  return [filter, setFilter];
};

export const useContent = (): [string, (value?: string) => void] => {
  const content = useFiltersStore((state) => state.content);
  const setContent = useFiltersStore((state) => state.setContent);

  return [content, setContent];
};
